import React from 'react';

const LIMITS = { percentage: { gateway_fee: 10, gst: 28 }, fixed: { gateway_fee: 10000, gst: 100000 } };
const ROWS = [
  ['gateway_fee', 'Platform Fee – Payment Gateway Charges', 'Passes the online payment processing cost to the payer. Not refunded on refunds.'],
  ['gst', 'GST', 'Tax on the registration amount (not on the gateway fee).'],
];
export const DEFAULT_CHARGES = { gateway_fee: { enabled: false, type: 'percentage', value: 0 }, gst: { enabled: false, type: 'percentage', value: 0 } };

export const chargesError = (ch) => {
  for (const [k, label] of ROWS) {
    const c = ch?.[k];
    if (!c?.enabled) continue;
    const max = LIMITS[c.type][k];
    if (!(c.value > 0) || c.value > max) return `${label}: enter a value greater than 0 and up to ${max}${c.type === 'percentage' ? '%' : ' INR'}`;
  }
  return '';
};

// Optional organiser charges, both off by default; applied on top of the registration fee at checkout.
export const ExtraChargesFields = ({ value, onChange, price }) => {
  const ch = value || DEFAULT_CHARGES;
  const set = (k, patch) => onChange({ ...ch, [k]: { ...ch[k], ...patch } });
  const err = chargesError(ch);
  return (
    <div className="rounded-lg border border-gray-200 p-4 space-y-3" data-testid="extra-charges-fields">
      <div>
        <p className="text-sm font-semibold text-[#191919]">Additional charges (optional)</p>
        <p className="text-xs text-[#666]">Off by default. Participants see each enabled charge itemised before they pay. Coupons don't reduce these charges.</p>
      </div>
      {ROWS.map(([k, label, hint]) => {
        const c = ch[k];
        const preview = c.enabled && price > 0 ? (c.type === 'percentage' ? (price * c.value) / 100 : c.value) : 0;
        return (
          <div key={k} className="space-y-2" data-testid={`charge-row-${k}`}>
            <label className="flex items-center gap-2 text-sm font-medium text-[#191919]">
              <input type="checkbox" checked={c.enabled} onChange={(e) => set(k, { enabled: e.target.checked })} className="rounded" data-testid={`charge-${k}-toggle`} />
              {label}
            </label>
            {c.enabled && (
              <div className="pl-6 space-y-1">
                <div className="flex gap-2">
                  <select value={c.type} onChange={(e) => set(k, { type: e.target.value })} className="px-2 py-2 border border-gray-300 rounded-lg text-sm" data-testid={`charge-${k}-type`}>
                    <option value="percentage">Percentage (%)</option>
                    <option value="fixed">Fixed amount (INR)</option>
                  </select>
                  <input type="number" min={0} step="0.01" value={c.value} onChange={(e) => set(k, { value: parseFloat(e.target.value) || 0 })}
                    className="w-32 px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid={`charge-${k}-value`} />
                </div>
                <p className="text-[11px] text-[#666]">{hint}{preview > 0 && ` On INR ${price.toLocaleString()}: + INR ${preview.toFixed(2)}${c.type === 'fixed' ? ' per payment' : ''}.`}</p>
              </div>
            )}
          </div>
        );
      })}
      {err && <p className="text-xs text-red-600" data-testid="extra-charges-error">{err}</p>}
    </div>
  );
};
